// extracted by mini-css-extract-plugin
export default {"item":"styles_item__SGvY4","mail":"styles_mail__PcN5M","department":"styles_department__o-CjM","data":"styles_data__8iNh2"};